<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxContactCell from "../../../../../../_shared/_modules/inbox-contact-cell"
  import type { ContactPointSourceCleanupDraft, ContactPointSourceCleanupRow } from "../../contract"
  let {
    row,
    disabled,
  }: InboxWorkflowCellProps<ContactPointSourceCleanupRow, ContactPointSourceCleanupDraft> = $props()
</script>

<InboxContactCell
  label={row.customerLabel}
  roleLabel={row.customerRoleLabel}
  email={row.customerEmail}
  phone={row.customerPhone}
  unitLabel={row.unitLabel}
  {disabled}
/>
